import { useState, Fragment, useEffect } from "react";
import styles from "../devicebackup.module.scss";
import {
  Button,
  Form,
  Select,
  message,
  Row,
  Col,
  Divider,
  Popover,
  Card,
  Tooltip,
  DatePicker,
  Grid,
  FormInstance,
} from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useUpdateDeviceAction } from "../queries";
import { useDeviceConfigForFilter, useIdentity, useUpdateEventLog } from "Components/Topology/queries";
import { useRepositoryList } from "../queries";
import { getOptionsFromIdentity, getSim1Apn, getSim2Apn, getWanEthApn } from "./utils";
import { setModelList } from "../store/upgradeSlice";
import { FilterOutlined } from "@ant-design/icons";

const { Option } = Select;
const { useBreakpoint } = Grid;

interface IdeviceIdentity {
  id: string;
  a: string;
  b: string;
  active: string;
  model: string;
  group: string[];
  location: string;
  currentMCSV: string;
  upgradeMCSV: string;
  wanEth: string;
  sim1Apn: string;
  sim2Apn: string;
}

interface Icondition {
  model: string;
  partitionA: string[];
  partitionB: string[];
  action: string;
  active: string[];
  location: string[];
  group: string[];
  currentMCSV: string[];
  upgradeMCSV: string[];
  wanEth: string[];
  sim1Apn: string[];
  sim2Apn: string[];
}

const initialCondition = {
  model: "",
  partitionA: [],
  partitionB: [],
  action: "",
  active: [],
  location: [],
  group: [],
  currentMCSV: [],
  upgradeMCSV: [],
  wanEth: [],
  sim1Apn: [],
  sim2Apn: [],
};

const initialIdentityOptions = {
  aMCSV: [],
  bMCSV: [],
  models: [],
  locations: [],
  groups: [],
  currentMCSV: [],
  upgradeMCSV: [],
  wanEth: [],
  sim1Apn: [],
  sim2Apn: [],
};

const ActionRequest = () => {
  const screens = useBreakpoint();
  const [ActionList, setActionList] = useState<any[]>([]);
  const { t } = useTranslation();
  const [isFilterFormChange, setIsFilterFormChange] = useState(false);
  const [DeviceSearch, setDeviceSearch] = useState<string | undefined>("any");
  const [scheduleValid, setScheduleValid] = useState<any>({ select: false, model: "" });
  const [selectModel, setSelectModel] = useState<any>({ select: false, model: "" });
  const [filterVisible, setFilterVisible] = useState(false);
  const { level, stateCid, loginCid, user, time_zone } = useAppSelector((state) => state.global);
  const [filterCondition, setFilterCondition] = useState<Icondition>(initialCondition);
  const [filteredDevice, setFilteredDevice] = useState([]);
  const [availableUpgradeMCSV, setAvailableUpgradeMCSV] = useState<any[]>([]);

  const [identityArr, setIdentityArr] = useState([]);
  const { actionStatusList, upgradeLoading } = useAppSelector((state) => state.upgrade);
  const { mutateAsync: submitRequest } = useUpdateDeviceAction(stateCid);
  const [form] = Form.useForm();
  const [FileRepository, setFileRepository] = useState<string[]>([]);
  const [restoreFileRepository, setRestoreFileRepository] = useState<string[]>([]);
  const { data: identity } = useIdentity(level, stateCid, loginCid);
  const { data: repositoryList } = useRepositoryList(level, stateCid, loginCid);
  const [identityOptions, setIdentityOptions] = useState(initialIdentityOptions);
  const [deviceIdentity, setDeviceIdentity] = useState([]);
  const forbiddenLevel = level === "get" || (level === "super_super" && stateCid === "");
  const disp = useAppDispatch();
  const { mutateAsync: setEventLogMutation } = useUpdateEventLog();
  const isUserCid = loginCid == "osmart" ? stateCid : loginCid;
  const selectedModel = Form.useWatch("Model", form);
  const {
    data: deviceConfig,
    isFetching: deviceConfigFetching,
    refetch: deviceConfigRefetch,
  } = useDeviceConfigForFilter(selectedModel, isUserCid);

  useEffect(() => {
    if (selectedModel !== "") {
      deviceConfigRefetch();
    }
  }, [selectedModel]);
  let model_options: any = new Set();
  identity?.response?.device_identity
    .filter((item: any) => item.nodeInf.health !== "offline")
    .map((item: any) => {
      model_options.add(item.nodeInf.model);
    });
  model_options = Array.from(model_options);

  useEffect(() => {
    form.setFieldsValue({
      utc: moment(),
    });
  }, []);

  useEffect(() => {
    if (!deviceConfig) {
      return;
    }

    const {
      deviceIdentity,
      aMCSV,
      bMCSV,
      models,
      locations,
      groups,
      currentMCSV,
      upgradeMCSV,
      wanEth,
      sim1Apn,
      sim2Apn,
    } = getOptionsFromIdentity(deviceConfig);

    setIdentityOptions({ aMCSV, bMCSV, models, locations, groups, currentMCSV, upgradeMCSV, wanEth, sim1Apn, sim2Apn });
    disp(setModelList(models));
    setDeviceIdentity(deviceIdentity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceConfig]);

  useEffect(() => {
    if (repositoryList?.length) {
      let FileList: any = new Set();
      repositoryList.map((item: any) => {
        item.list.map((file: any) => FileList.add(file));
      });
      FileList = Array.from(FileList);
      setFileRepository(FileList);
      setRestoreFileRepository(FileList);
    } else {
      setFileRepository([]);
      setRestoreFileRepository([]);
    }
  }, [repositoryList]);

  useEffect(() => {
    if (actionStatusList) {
      //找出action list中, 那些是已經結束的狀態
      let ActionList = actionStatusList
        .filter(
          (item: { state: string }) =>
            item.state !== "START_REBOOT" &&
            item.state !== "FILE_UPLOAD" &&
            item.state !== "COMMAND_ERROR" &&
            item.state !== "FILE_ERROR"
        )
        .map((item: { id: string }) => item.id);
      setActionList(ActionList);
    }
  }, [actionStatusList]);

  useEffect(() => {
    if (deviceIdentity?.length) {
      const matchChecker = (condition: string | string[], item: string) => {
        if (condition.length && typeof condition !== "string") {
          return condition.includes(item);
        } else if (typeof condition === "string") {
          return condition === item;
        } else {
          return true;
        }
      };

      // 提取符合條件的 upgradeMCSV
      const uniqueUpgradeMCSV = deviceIdentity
        ?.filter((item: IdeviceIdentity) => {
          const groupMatchCondition = item.group.filter((groupName) => filterCondition.group?.indexOf(groupName) > -1);

          // 套用過濾條件
          return (
            matchChecker(filterCondition.model, item.model) &&
            matchChecker(filterCondition.partitionA, item.a) &&
            matchChecker(filterCondition.partitionB, item.b) &&
            matchChecker(filterCondition.active, item.active) &&
            matchChecker(filterCondition.location, item.location) &&
            matchChecker(filterCondition.wanEth, item.wanEth) &&
            matchChecker(filterCondition.sim1Apn, item.sim1Apn) &&
            matchChecker(filterCondition.sim2Apn, item.sim2Apn) &&
            matchChecker(filterCondition.currentMCSV, item.currentMCSV) &&
            matchChecker(filterCondition.group, groupMatchCondition[0])
          );
        })
        .reduce((uniqueList: any[], item: any) => {
          if (!uniqueList.find((uniqueItem) => uniqueItem.upgradeMCSV === item.upgradeMCSV)) {
            uniqueList.push(item);
          }
          return uniqueList;
        }, [])
        ?.map((item) => item.upgradeMCSV); // 提取 upgradeMCSV 值

      // 更新 uniqueUpgradeMCSV 狀態
      setAvailableUpgradeMCSV(uniqueUpgradeMCSV || []);

      // 過濾裝置資料
      const filteredDevice = deviceIdentity?.filter((item: IdeviceIdentity) => {
        const groupMatchCondition = item.group.filter((groupName) => filterCondition.group?.indexOf(groupName) > -1);
        return (
          matchChecker(filterCondition.model, item.model) &&
          matchChecker(filterCondition.partitionA, item.a) &&
          matchChecker(filterCondition.partitionB, item.b) &&
          matchChecker(filterCondition.active, item.active) &&
          matchChecker(filterCondition.location, item.location) &&
          matchChecker(filterCondition.wanEth, item.wanEth) &&
          matchChecker(filterCondition.sim1Apn, item.sim1Apn) &&
          matchChecker(filterCondition.sim2Apn, item.sim2Apn) &&
          matchChecker(filterCondition.currentMCSV, item.currentMCSV) &&
          matchChecker(filterCondition.upgradeMCSV, item.upgradeMCSV) &&
          matchChecker(filterCondition.group, groupMatchCondition[0])
        );
      });

      setFilteredDevice(filteredDevice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterCondition, stateCid]);

  //改變Action時, 更新可選擇到的FileType
  const changeAction = (value: string) => {
    setFilterCondition((preveState) => ({ ...preveState, action: value }));
    let fileType: string;
    if (value === "upgrade") {
      fileType = "fw";
    } else if (value === "restore") {
      fileType = "cfg";
    }

    let filterFilebyAction = restoreFileRepository?.filter(
      (item: any) => item.type === fileType && item.inf.model === filterCondition.model
    );
    setFileRepository(filterFilebyAction);
    form.resetFields(["files"]);
  };

  const SelectAll = () => {
    const allDevice: string[] = filteredDevice
      ?.filter((item: any) => !ActionList.includes(item.id))
      .map((item: any) => (item.name !== "" ? item.name : item.id));
    form.setFieldsValue({
      Device_ID: allDevice,
    });
  };

  function ClearAll() {
    form.setFieldsValue({
      Device_ID: [],
    });
  }

  const SubmitOnFinish = (values: any) => {
    if (values.utc < moment()) {
      values.utc = moment();
    }

    values.Device_ID = values.Device_ID.map((item: any) => {
      const MapNameToID: any = filteredDevice.filter((fitem: any) => fitem.name === item || fitem.id === item);
      return MapNameToID[0].id;
    });
    submitRequest({ level, stateCid, loginCid, time_zone, values })
      .then(() => {
        message.success(t("ISMS.Success"));
        form.resetFields();
        form.setFieldsValue({
          utc: moment(),
        });
        const isSuprt = level === "super_super";
        const eventmessage = `${user} ${values.Action} ${values.Device_ID.length} devices`;
        const cid = isSuprt ? stateCid : loginCid;
        setEventLogMutation({ cid, message: eventmessage });
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
        form.resetFields();
        form.setFieldsValue({
          utc: moment(),
        });
      });
  };

  const handleVisibleChange = (visible: boolean) => {
    setFilterVisible(visible);
    if (isFilterFormChange) {
      form.resetFields(["Device_ID"]);
    }
    setIsFilterFormChange(false);
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    // Can not select days before today and today
    return current < moment().subtract(1, "days").endOf("day");
  };

  const props = {
    upgradeLoading,
    setIsFilterFormChange,
    setFilterCondition,
    identityOptions,
    t,
    filteredDevice,
    availableUpgradeMCSV,
    filterCondition,
    form,
    deviceConfig,
    setIdentityOptions,
    selectModel,
    identityArr,
    setIdentityArr,
  };
  // @ts-ignore
  const content = filterContent(props);

  const range = (start: any, end: any) => {
    const result = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (date: any) => {
    let hours = moment().hours(); // 當下小時
    let minutes = moment().minutes(); // 當下分鐘
    // let seconds = moment().seconds(); // 當下秒

    if (
      moment(date).year() === moment().year() &&
      moment(date).month() === moment().month() &&
      moment(date).date() === moment().date()
    ) {
      // 當下日期 比對 年 && 月 && 日 = 選擇日期
      return {
        disabledHours: () => range(0, hours - 1),
        disabledMinutes: () => (moment(date).hours() === moment().hours() ? range(0, minutes - 1) : []),
        // disabledSeconds: () => range(seconds + 1, 59),
      };
    }

    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      // disabledSeconds: () => [],
    };
  };

  return (
    <Card bordered={true} title={t("ISMS.Action Request")}>
      <Form onFinish={SubmitOnFinish} form={form} layout="vertical">
        <div className="formwrap">
          <Row gutter={24}>
            <Col xs={24} sm={10} md={10} lg={6} xl={4}>
              <Form.Item
                label={t("ISMS.Model")}
                name="Model"
                rules={[{ required: true, message: "Model is required" }]}
              >
                <Select
                  loading={upgradeLoading || deviceConfigFetching}
                  disabled={deviceConfigFetching}
                  placeholder={t("ISMS.Select")}
                  onChange={(value) => {
                    setSelectModel({ select: true, model: value });
                    form.resetFields([
                      ["Device_ID"],
                      ["Action"],
                      ["group"],
                      ["location"],
                      ["active"],
                      ["partitionA"],
                      ["partitionB"],
                      ["wanEth"],
                      ["sim1Apn"],
                      ["sim2Apn"],
                      ["currentMCSV"],
                      ["upgradeMCSV"],
                    ]);
                    //@ts-ignore
                    setFilterCondition({
                      model: value,
                      partitionA: [],
                      partitionB: [],
                      action: "",
                      active: [],
                      location: [],
                      group: [],
                      currentMCSV: [],
                      upgradeMCSV: [],
                      wanEth: [],
                      sim1Apn: [],
                      sim2Apn: [],
                    });
                    const updatedIdentity: any = { response: { device_cfg: [] } };
                    const identity_arr: any = [];
                    deviceConfig?.response?.device_cfg?.map((item: any) => {
                      if (item.nodeInf.model === value) {
                        identity_arr.push(item);
                      }
                    });
                    updatedIdentity.response.device_cfg = identity_arr;
                    const {
                      aMCSV,
                      bMCSV,
                      models,
                      locations,
                      groups,
                      currentMCSV,
                      upgradeMCSV,
                      wanEth,
                      sim1Apn,
                      sim2Apn,
                    } = getOptionsFromIdentity(updatedIdentity);
                    setIdentityOptions({
                      aMCSV,
                      bMCSV,
                      models,
                      locations,
                      groups,
                      currentMCSV,
                      upgradeMCSV,
                      wanEth,
                      sim1Apn,
                      sim2Apn,
                    });
                  }}
                >
                  {model_options.map((item: any, index: number) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={10} md={10} lg={6} xl={4}>
              <Form.Item
                label={t("ISMS.Action")}
                name="Action"
                tooltip="Backup as cfg file to Repository (or) Restore device by file(cfg) (or) Upgrade device by file(fw)"
                rules={[{ required: true, message: "Action is required" }]}
              >
                <Select
                  loading={upgradeLoading || deviceConfigFetching}
                  disabled={deviceConfigFetching}
                  showSearch
                  showArrow
                  placeholder={t("ISMS.Select")}
                  onChange={(value: string) => {
                    changeAction(value);
                    // setAction(value)
                  }}
                >
                  <Option value="upgrade">{t("ISMS.Upgrade")}</Option>
                  <Option value="backup">{t("ISMS.Backup")}</Option>
                  <Option value="restore">{t("ISMS.Restore")}</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={20} md={10} lg={7} xl={7}>
              <Form.Item
                label={
                  <Fragment>
                    {t("ISMS.Device")}
                    <Popover
                      content={selectModel.select && content}
                      // title="Title"
                      trigger="click"
                      visible={filterVisible}
                      onVisibleChange={handleVisibleChange}
                    >
                      {/* <span className={styles.deviceFilter}>{t("ISMS.Filter")}</span> */}
                      <Tooltip title={!selectModel.select ? t("ISMS.Select model first") : ""}>
                        <Button
                          size="small"
                          type="text"
                          disabled={!selectModel.select}
                          icon={<FilterOutlined />}
                        ></Button>
                      </Tooltip>
                    </Popover>
                  </Fragment>
                }
                name="Device_ID"
                tooltip='"UP" device only'
                rules={[{ required: true, message: "Deivce Id is required!" }]}
              >
                <Select
                  loading={upgradeLoading || deviceConfigFetching}
                  disabled={deviceConfigFetching}
                  autoClearSearchValue={false}
                  mode="multiple"
                  //@ts-ignore
                  maxTagCount={"responsive"}
                  placeholder={t("ISMS.Select")}
                  onBlur={() => setDeviceSearch("any")}
                  onSearch={(value) => {
                    if (value === "") {
                      setDeviceSearch("any");
                    } else {
                      setDeviceSearch(undefined);
                    }
                  }}
                  defaultActiveFirstOption={true}
                  dropdownRender={(menu) => (
                    <Fragment>
                      {menu}
                      {DeviceSearch && (
                        <Fragment>
                          <Divider style={{ margin: "4px 0" }} />
                          <Button onClick={() => SelectAll()} style={{ margin: "5px", padding: "3px 5px" }}>
                            {t("ISMS.SelectAll")}
                          </Button>
                          <Button onClick={() => ClearAll()} style={{ margin: "5px", padding: "3px 5px" }}>
                            {t("ISMS.ClearAll")}
                          </Button>
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                >
                  {filteredDevice.map((item: any, index: number) => {
                    return (
                      <Option
                        key={index}
                        value={item.name !== "" ? item.name : item.id}
                        disabled={ActionList.includes(item.id)}
                      >
                        {item.name !== "" ? item.name : item.id} {ActionList.includes(item.id) && "(processing)"}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={10} md={10} lg={7} xl={7}>
              <Form.Item
                label={t("ISMS.File")}
                name="files"
                tooltip="Upgrade:fw, Restore:cfg, Backup:none"
                rules={[
                  {
                    required: filterCondition.action === "backup" ? false : true,
                    message: "File is required!",
                  },
                ]}
              >
                <Select
                  loading={upgradeLoading || deviceConfigFetching}
                  disabled={filterCondition.action === "backup" ? true : false || deviceConfigFetching}
                  showSearch
                  placeholder={t("ISMS.Select")}
                  optionFilterProp="children"
                  notFoundContent={"Not available"}
                >
                  {FileRepository?.map((item: any, index) => (
                    <Option key={index} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={10} md={10} lg={6} xl={4}>
              <Form.Item
                label={t("ISMS.Schedule")}
                name="utc"
                tooltip=""
                // initialValue={moment()}
                // rules={[
                //   {
                //     required: !scheduleValid,
                //     message: "Please choose correct schedule day and time!",
                //   },
                // ]}
              >
                <DatePicker
                  showNow
                  disabled={deviceConfigFetching}
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD HH:mm"
                  disabledDate={disabledDate}
                  disabledTime={disabledDateTime}
                  showTime={{ defaultValue: moment("HH:mm") }}
                  onOk={(value) => {
                    if (value < moment()) {
                      form.setFieldsValue({
                        utc: moment(),
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col
              xs={10}
              sm={10}
              md={10}
              lg={6}
              xl={24}
              style={screens.xl ? { display: "flex", justifyContent: "flex-end" } : {}}
            >
              <Form.Item className={styles.submitBtn}>
                <Tooltip placement="topLeft" title={forbiddenLevel ? "level: super_super/get not allowed" : ""}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className={styles.clickBtn}
                    disabled={forbiddenLevel || deviceConfigFetching}
                    loading={upgradeLoading || deviceConfigFetching}
                  >
                    {t("ISMS.Submit")}
                  </Button>
                </Tooltip>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Card>
  );
};

export default ActionRequest;

interface filterContentProps {
  upgradeLoading: boolean;
  setIsFilterFormChange: (arg: boolean) => void;
  setFilterCondition: (arg: any) => void;
  identityOptions: any;
  filteredDevice: any;
  filterCondition: any;
  availableUpgradeMCSV: any;
  t: any;
  deviceConfig: any;
  setIdentityOptions: (arg: any) => void;
  selectModel: any;
  identityArr: any;
  setIdentityArr: (arg: any) => void;
  form: FormInstance;
}

const filterContent = ({
  upgradeLoading,
  setIsFilterFormChange,
  setFilterCondition,
  identityOptions,
  availableUpgradeMCSV,
  filteredDevice,
  filterCondition,
  form,
  t,
  deviceConfig,
  setIdentityOptions,
  selectModel,
  identityArr,
  setIdentityArr,
}: filterContentProps) => {
  return (
    <div className="formwrap" style={{ width: "380px", padding: "5px" }}>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Group")} name="group">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.Group")}
            onChange={(value: any) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({
                ...preveState,
                group: value,
                location: [],
                wanEth: [],
                sim1Apn: [],
                sim2Apn: [],
                currentMCSV: [],
                upgradeMCSV: [],
              }));
              const updatedIdentity: any = { response: { device_cfg: [] } };
              const identity_arr: any = [];
              const identity_data = identityArr.length > 0 ? identityArr : deviceConfig?.response?.device_cfg;
              if (value.length > 0) {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  // gid: ["g1", "g2"]
                  value.map((val: any) => {
                    if (item.nodeInf.gid.includes(val)) {
                      identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_cfg = identity_arr;
                const filteredDevices = {
                  ...updatedIdentity,
                  response: {
                    ...updatedIdentity.response,
                    device_cfg: updatedIdentity.response.device_cfg.filter(
                      (device: any) => device.nodeInf.model === selectModel.model
                    ),
                  },
                };

                const { aMCSV, bMCSV, models, locations, currentMCSV, upgradeMCSV, wanEth, sim1Apn, sim2Apn } =
                  getOptionsFromIdentity(filteredDevices);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  locations,
                  currentMCSV,
                  upgradeMCSV,
                  wanEth,
                  sim1Apn,
                  sim2Apn,
                });
                setIdentityArr(identity_arr);
              } else {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  if (item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_cfg = identity_arr;
                const { aMCSV, bMCSV, models, groups, locations, currentMCSV, upgradeMCSV, wanEth, sim1Apn, sim2Apn } =
                  getOptionsFromIdentity(updatedIdentity);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  groups,
                  locations,
                  wanEth,
                  sim1Apn,
                  sim2Apn,
                  currentMCSV,
                  upgradeMCSV,
                });
                setIdentityArr(identity_arr);
              }
              form.resetFields([["location"], ["wanEth"], ["sim1Apn"], ["sim2Apn"], ["currentMCSV"], ["upgradeMCSV"]]);
            }}
          >
            {identityOptions.groups?.sort().map((item: string, index: number) => (
              <Option key={index} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Location")} name="location">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.Location")}
            onChange={(value: any) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({
                ...preveState,
                location: value,
                wanEth: [],
                sim1Apn: [],
                sim2Apn: [],
                currentMCSV: [],
                upgradeMCSV: [],
              }));
              const updatedIdentity: any = { response: { device_cfg: [] } };
              const identity_arr: any = [];
              const identity_data = identityArr.length > 0 ? identityArr : deviceConfig?.response?.device_cfg;
              if (value.length > 0) {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  value.map((val: any) => {
                    const groupCondition =
                      filterCondition.group.length >= 1
                        ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                        : true;

                    if (item.nodeInf.city === val && groupCondition && item.nodeInf.model === selectModel.model) {
                      identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_cfg = identity_arr;
                const filteredDevices = {
                  ...updatedIdentity,
                  response: {
                    ...updatedIdentity.response,
                    device_cfg: updatedIdentity.response.device_cfg.filter(
                      (device: any) => device.nodeInf.model === selectModel.model
                    ),
                  },
                };

                const { aMCSV, bMCSV, models, currentMCSV, upgradeMCSV, wanEth, sim1Apn, sim2Apn } =
                  getOptionsFromIdentity(filteredDevices);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  currentMCSV,
                  upgradeMCSV,
                  wanEth,
                  sim1Apn,
                  sim2Apn,
                });
                setIdentityArr(identity_arr);
              } else {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  const groupCondition =
                    filterCondition.group.length >= 1
                      ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                      : true;
                  if (groupCondition && item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_cfg = identity_arr;
                const { aMCSV, bMCSV, models, wanEth, sim1Apn, sim2Apn, upgradeMCSV, currentMCSV } =
                  getOptionsFromIdentity(updatedIdentity);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  wanEth,
                  sim1Apn,
                  sim2Apn,
                  upgradeMCSV,
                  currentMCSV,
                });
                setIdentityArr(identity_arr);
              }
              form.resetFields([["wanEth"], ["sim1Apn"], ["sim2Apn"], ["currentMCSV"], ["upgradeMCSV"]]);
            }}
          >
            {identityOptions.locations?.sort().map((item: string, index: number) => (
              <Option key={index} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Firmware")} name="Firmware">
          <Select
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.Firmware")}
            onChange={(value: any) => {
              console.log("value", value);
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, firmware: value }));
              const updatedIdentity: any = { response: { device_identity: [] } };
              console.log("updatedIdentity", updatedIdentity);
              const identity_arr: any = [];
              const identity_data = identityArr.length > 0 ? identityArr : identity?.response?.device_identity;
              if (value.length > 0) {
                identity?.response?.device_identity.map((item: any) => {
                  // gid: ["g1", "g2"]
                  value.map((val: any) => {
                    if (item.nodeInf.gid.includes(val)) {
                      identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_identity = identity_arr;
                const { aMCSV, bMCSV, models } = getOptionsFromIdentity(updatedIdentity);
                setIdentityOptions({ ...identityOptions, aMCSV, bMCSV, models });
                setIdentityArr(identity_arr);
              } else {
                identity?.response?.device_identity.map((item: any) => {
                  if (item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_identity = identity_arr;
                const { aMCSV, bMCSV, models, groups, locations, firmware } = getOptionsFromIdentity(updatedIdentity);
                setIdentityOptions({ ...identityOptions, aMCSV, bMCSV, models, groups, locations, firmware });
                setIdentityArr(identity_arr);
              }
            }}
          >
            {identityOptions.firmware?.sort().map((item: string, index: number) => (
              <Option key={index} value={item}>
                {`V${(Number(item.slice(-8, -5)) / 100).toFixed(2)}-${item.slice(-8)}`}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
      {/* <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Active")} name="active">
          <Select
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.Active Image Partition")}
            onChange={(value: string) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, active: value }));
            }}
          >
            <Option key={"A"} value={"a"}>
              A
            </Option>
            <Option key={"B"} value={"b"}>
              B
            </Option>
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Dual Image A MCSV")} name="partitionA">
          <Select
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.MCSV")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, partitionA: value }));
            }}
          >
            {identityOptions.aMCSV?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {`V${(Number(item.slice(-8, -5)) / 100).toFixed(2)}-${item.slice(-8)}`}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Dual Image B MCSV")} name="partitionB">
          <Select
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.MCSV")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, partitionB: value }));
            }}
          >
            {identityOptions.bMCSV?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {`V${(Number(item.slice(-8, -5)) / 100).toFixed(2)}-${item.slice(-8)}`}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col> */}
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.WAN Ethernet")} name="wanEth">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.WAN Ethernet")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, wanEth: value, currentMCSV: [], upgradeMCSV: [] }));
              const updatedIdentity: any = { response: { device_cfg: [] } };
              const identity_arr: any = [];
              if (value.length > 0) {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  value.map((val: any) => {
                    const groupCondition =
                      filterCondition.group.length >= 1
                        ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                        : true;
                    const locationCondition =
                      filterCondition.location.length >= 1
                        ? filterCondition.location.includes(item.nodeInf.city)
                        : true;
                    const wanEth = getWanEthApn(item);

                    if (wanEth && groupCondition && locationCondition && item.nodeInf.model === selectModel.model) {
                      if (val.includes(wanEth)) identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_cfg = identity_arr;
                const filteredDevices = {
                  ...updatedIdentity,
                  response: {
                    ...updatedIdentity.response,
                    device_cfg: updatedIdentity.response.device_cfg.filter(
                      (device: any) => device.nodeInf.model === selectModel.model
                    ),
                  },
                };

                const { aMCSV, bMCSV, models, currentMCSV, upgradeMCSV, sim1Apn, sim2Apn } =
                  getOptionsFromIdentity(filteredDevices);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  sim1Apn,
                  sim2Apn,
                  currentMCSV,
                  upgradeMCSV,
                });
                setIdentityArr(identity_arr);
              } else {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  const groupCondition =
                    filterCondition.group.length >= 1
                      ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                      : true;
                  const locationCondition =
                    filterCondition.location.length >= 1 ? filterCondition.location.includes(item.nodeInf.city) : true;
                  if (groupCondition && locationCondition && item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_cfg = identity_arr;
                const { aMCSV, bMCSV, models, sim1Apn, sim2Apn, upgradeMCSV, currentMCSV } =
                  getOptionsFromIdentity(updatedIdentity);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  sim1Apn,
                  sim2Apn,
                  upgradeMCSV,
                  currentMCSV,
                });
                setIdentityArr(identity_arr);
              }
              form.resetFields([["upgradeMCSV"], ["currentMCSV"]]);
            }}
          >
            {identityOptions?.wanEth?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.SIM1 Apn")} name="sim1Apn">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.SIM1 Apn")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, sim1Apn: value, currentMCSV: [], upgradeMCSV: [] }));
              const updatedIdentity: any = { response: { device_cfg: [] } };
              const identity_arr: any = [];
              if (value.length > 0) {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  value.map((val: any) => {
                    const sim1ApnVal = getSim1Apn(item);

                    const groupCondition =
                      filterCondition.group.length >= 1
                        ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                        : true;
                    const locationCondition =
                      filterCondition.location.length >= 1
                        ? filterCondition.location.includes(item.nodeInf.city)
                        : true;
                    if (groupCondition && locationCondition && item?.nodeInf?.model === selectModel?.model) {
                      if (val.includes(sim1ApnVal)) identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_cfg = identity_arr;
                const filteredDevices = {
                  ...updatedIdentity,
                  response: {
                    ...updatedIdentity.response,
                    device_cfg: updatedIdentity.response.device_cfg.filter(
                      (device: any) => device.nodeInf.model === selectModel.model
                    ),
                  },
                };

                const { aMCSV, bMCSV, models, groups, locations, currentMCSV, upgradeMCSV, wanEth, sim2Apn } =
                  getOptionsFromIdentity(filteredDevices);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  wanEth,
                  sim2Apn,
                  currentMCSV,
                  upgradeMCSV,
                });
                setIdentityArr(identity_arr);
              } else {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  const groupCondition =
                    filterCondition.group.length >= 1
                      ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                      : true;
                  const locationCondition =
                    filterCondition.location.length >= 1 ? filterCondition.location.includes(item.nodeInf.city) : true;
                  if (groupCondition && locationCondition && item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_cfg = identity_arr;
                const { aMCSV, bMCSV, models, upgradeMCSV, currentMCSV, wanEth, sim2Apn } =
                  getOptionsFromIdentity(updatedIdentity);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  wanEth,
                  sim2Apn,
                  upgradeMCSV,
                  currentMCSV,
                });
                setIdentityArr(identity_arr);
              }
              form.resetFields([["upgradeMCSV"], ["currentMCSV"]]);
            }}
          >
            {identityOptions?.sim1Apn?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.SIM2 Apn")} name="sim2Apn">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.SIM2 Apn")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, sim2Apn: value, currentMCSV: [], upgradeMCSV: [] }));
              const updatedIdentity: any = { response: { device_cfg: [] } };
              const identity_arr: any = [];
              if (value.length > 0) {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  value.map((val: any) => {
                    const sim2ApnVal = getSim2Apn(item);

                    const groupCondition =
                      filterCondition.group.length >= 1
                        ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                        : true;
                    const locationCondition =
                      filterCondition.location.length >= 1
                        ? filterCondition.location.includes(item.nodeInf.city)
                        : true;
                    if (groupCondition && locationCondition && item?.nodeInf?.model === selectModel?.model) {
                      if (val.includes(sim2ApnVal)) identity_arr.push(item);
                    }
                  });
                });

                updatedIdentity.response.device_cfg = identity_arr;
                const filteredDevices = {
                  ...updatedIdentity,
                  response: {
                    ...updatedIdentity.response,
                    device_cfg: updatedIdentity.response.device_cfg.filter(
                      (device: any) => device.nodeInf.model === selectModel.model
                    ),
                  },
                };

                const { aMCSV, bMCSV, models, currentMCSV, upgradeMCSV, wanEth, sim1Apn } =
                  getOptionsFromIdentity(filteredDevices);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  wanEth,
                  sim1Apn,
                  currentMCSV,
                  upgradeMCSV,
                });
                setIdentityArr(identity_arr);
              } else {
                deviceConfig?.response?.device_cfg.map((item: any) => {
                  const groupCondition =
                    filterCondition.group.length >= 1
                      ? item.nodeInf.gid.some((gid: string) => filterCondition.group.includes(gid))
                      : true;
                  const locationCondition =
                    filterCondition.location.length >= 1 ? filterCondition.location.includes(item.nodeInf.city) : true;
                  if (groupCondition && locationCondition && item.nodeInf.model === selectModel.model) {
                    identity_arr.push(item);
                  }
                });
                updatedIdentity.response.device_cfg = identity_arr;
                const { aMCSV, bMCSV, models, upgradeMCSV, currentMCSV, wanEth, sim1Apn } =
                  getOptionsFromIdentity(updatedIdentity);

                setIdentityOptions({
                  ...identityOptions,
                  aMCSV,
                  bMCSV,
                  models,
                  wanEth,
                  sim1Apn,
                  upgradeMCSV,
                  currentMCSV,
                });
                setIdentityArr(identity_arr);
              }
              form.resetFields([["upgradeMCSV"], ["currentMCSV"]]);
            }}
          >
            {identityOptions?.sim2Apn?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item} label={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Current Image MCSV")} name="currentMCSV">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.MCSV")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, currentMCSV: value, upgradeMCSV: [] }));
              form.resetFields([["upgradeMCSV"]]);
            }}
          >
            {identityOptions?.currentMCSV?.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {/* {`V${(Number(item.slice(-8, -5)) / 100).toFixed(2)}-${item.slice(-8)}`} */}
                  {`V${(Number(item?.slice(-8, -5)) / 100)?.toFixed(2)}-${item}`}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={14} md={24} lg={24} xl={24}>
        <Form.Item label={t("ISMS.Ready Upgrade Image MCSV")} name="upgradeMCSV">
          <Select
            allowClear
            loading={upgradeLoading}
            autoClearSearchValue={false}
            mode="multiple"
            //@ts-ignore
            maxTagCount={"responsive"}
            placeholder={t("ISMS.MCSV")}
            onChange={(value) => {
              setIsFilterFormChange(true);
              //@ts-ignore
              setFilterCondition((preveState) => ({ ...preveState, upgradeMCSV: value }));
            }}
            disabled={filterCondition?.currentMCSV?.length === 0}
          >
            {availableUpgradeMCSV?.map((upgradeMCSV: string, index: number) => (
              <Option key={index} value={upgradeMCSV}>
                {/* {`V${(Number(upgradeMCSV.slice(-8, -5)) / 100).toFixed(2)}-${upgradeMCSV.slice(-8)}`} */}
                {`V${(Number(upgradeMCSV?.slice(-8, -5)) / 100)?.toFixed(2)}-${upgradeMCSV}`}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </div>
  );
};
